/**
 * Lectura de la config de RUNTIME que nginx inyecta al arrancar el contenedor
 * (`runtime-config.template.js` → `envsubst` → `/runtime-config.js`, cargado por `index.html`
 * antes del bundle).
 *
 * Existe porque los build-args de Vite NO llegan al build en SleakOps: lo que se hornea queda
 * vacío. Todo lo que tenga que variar por entorno sin rebuildear la imagen va por acá.
 */
declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Record<string, string | undefined>;
  }
}

/**
 * Valor crudo de una clave del runtime-config.
 *
 * Devuelve `""` tanto si falta como si quedó el placeholder sin sustituir (`${VITE_...}`): eso
 * pasa cuando la env no está seteada en el contenedor y `envsubst` deja el literal. Tratarlo como
 * vacío evita que ese string se use como si fuera un valor real.
 */
export function runtimeValue(key: string): string {
  const v = window.__RUNTIME_CONFIG__?.[key];
  return v && !v.includes("${") ? v.trim() : "";
}

